import { ToggleActivityStateFilter } from 'components/filters/ToggleActivityStateFilter';
import { ACTIVITY_STATE_ALL_VALUE } from 'components/filters/ToggleActivityStateFilter';
import React from 'react';
import { Filter } from 'react-admin';

import { TERMINAL_DEFAULT_VALUE } from '../../../components/filters/ToggleTerminalsFilter';

export const filterDefaultValues = {
	"terminal_id": [TERMINAL_DEFAULT_VALUE],
	"activity_state": ACTIVITY_STATE_ALL_VALUE
};


export const PortAreaFilters = ({ usesStorageModule, ...props }) => {
	return (
		<Filter {...props}>
			{!usesStorageModule ?
				<ToggleActivityStateFilter source="activity_state" defaultValue={null} alwaysOn key={"activity_state"}/>
			: null}
		</Filter>
	);
};
